import request from './request';

export const authAPI = {
  /** 登录 - 支持邮箱/手机号+密码，手机号+验证码 */
  login: (data) => request.post('/auth/login', data),
  /** 注册 - 邮箱+密码+昵称 */
  register: (data) => request.post('/auth/register', data),
  /** 发送短信验证码 */
  sendSmsCode: (phone) => request.post('/auth/sms-code', null, { params: { phone } }),
  /** 微信登录 */
  wechatLogin: (code) => request.post('/auth/wechat-login', null, { params: { code } }),
  /** 微信模拟登录 */
  wechatMock: () => request.post('/auth/wechat-mock'),
  /** 演示登录 */
  demoLogin: () => request.post('/auth/demo-login'),
  /** 获取用户信息 */
  getProfile: () => request.get('/user/self'),
  /** 更新用户信息 */
  updateProfile: (data) => request.put('/user/self', data),
};

export default authAPI;